import { Component } from '@angular/core';
import { ModalController } from 'ionic-angular';
import { SelfReportService } from './../../services/selfreport.service';
import { LoaddingService } from './../../providers/loadding.service';
import { UserReportModel } from './../../models/userreport.model';
import { StorageService } from './../../providers/storage.service';
import { PageDefault } from './../../pages/PageDefault';
import { UserModel } from './../../models/user.model';
import { SelfreportSearch } from './selfreportsearch';
import { AppConfig } from './../../app/app.config';

/*
    主账户报表
    TQQ 2016-12-28
*/
@Component({
  selector: 'self-report',
  templateUrl: 'selfreport.html',
  providers: [SelfReportService]
})

export class SelfReport {
  constructor(
    private selfreport: SelfReportService,
    private loadding: LoaddingService,
    private storage: StorageService,
    private modalCtrl: ModalController) { }


  UserType = AppConfig.User.UserType;
  modelList: UserReportModel[];
  currPage = 1;
  username = this.storage.read<UserModel>("User").UserName;
  excludeTracks = [];
  site = new SelfReportInput();
  isHave = true;
  time = new Date();
  selectNum: number = 0;

  ionViewDidLoad() {
    this.site.userName = this.storage.read<UserModel>("User").UserName;
    this.jinDay(0);
    // this.site.pageIndex = this.currPage;
    // let load = this.loadding.showLoding();
    // this.getSelfReport(this.site).then(s => {
    //   this.loadding.closeLoading(load);
    // });
  }

  //下拉重新加载
  //TQQ 2016-12-29
  doRefresh(refresher) {
    this.getSelfReport(this.site).then(s => {
      refresher.complete();
    });
  }

  //上拉获取下一页信息
  //TQQ 2016-12-29
  doInfinite(infiniteScroll) {
    this.currPage++;
    this.site.pageIndex = this.currPage;
    this.getSelfReport(this.site).then(s => {
      infiniteScroll.complete();
    });
  }

  //查询条件
  presentFilter() {
    let modal = this.modalCtrl.create(SelfreportSearch, this.excludeTracks);
    modal.present();
    modal.onWillDismiss((data: any[]) => {
      if (data) {
        this.excludeTracks = data;
        this.site.startDate = this.excludeTracks["startDate"];
        this.site.endDate = this.excludeTracks["endDate"];
        this.getSelfReport(this.site);
      }
    });
  }

  //获取主账户报表信息
  //TQQ 2016-12-28
  getSelfReport(obj) {
    return this.selfreport.getSelfReport(obj).then(s => {
      if (obj.pageIndex == 1) {
        this.modelList = [];
        this.modelList = s.List;
      } else {
        this.modelList = this.modelList.concat(s.List);
      }
      if (this.modelList == null || this.modelList.length < 1) {
        this.isHave = false;
      } else {
        this.isHave = true;
      }
    }).catch(c => {
    });
  }


  //近几天的快速查询
  //chen 2017-01-07
  jinDay(number) {
    this.selectNum = number;
    let before = new Date(this.time.getTime() - number * 24 * 60 * 60 * 1000);
    this.site.startDate = before.getFullYear() + "-" + (before.getMonth() + 1) + "-" + before.getDate();
    this.getSelfReport(this.site);
  }

  //一个月内的快速查询
  //chen 2017-01-07
  jinMonth() {
    this.selectNum = 30;
    this.site.startDate = this.time.getFullYear() + "-" + (this.time.getMonth() + 1) + "-01";
    this.getSelfReport(this.site);
  }

}
export class SelfReportInput {
  userName: string;
  startDate: string = PageDefault.startDate();
  endDate: string = PageDefault.endDate();
  pageIndex: number = 1;
  pageSize: number = PageDefault.PageSize();

}





// WEBPACK FOOTER //
// ./src/pages/selfreport/selfreport.ts